import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../assets/css/styles.css";
import how_to_place_an_order from "../assets/images/how_to_place_an_order.png";
import areas_to_deliver_to from "../assets/images/areas_to_deliver_to.png";
import is_the_produce_organic from "../assets/images/is_the_produce_organic.png";
import delivery_time from "../assets/images/delivery_time.png";

const QUESTIONS = [
  {
    id: "order",
    image: how_to_place_an_order,
    question: "How do I place an order?",
    answer:
      "Pick an open campaign, choose your product and share size, then check out securely online. Your order is confirmed automatically the moment payment goes through.",
  },
  {
    id: "areas",
    image: areas_to_deliver_to,
    question: "What areas do you deliver to?",
    answer:
      "We currently deliver across Calgary, Alberta. Enter your address at checkout and we will confirm straight away whether you are inside the delivery zone.",
  },
  {
    id: "timing",
    image: delivery_time,
    question: "When will my order arrive?",
    answer:
      "Deliveries go out within 7 business days of a campaign closing. Because every order in a campaign is packed together, the close date on the campaign is your best guide.",
  },
  {
    id: "fee",
    question: "How much is delivery?",
    answer:
      "A flat $15 per order, shown at checkout before you pay. There are no seasonal surcharges or distance-based fees inside our delivery area.",
  },
  {
    id: "sizes",
    question: "What share sizes can I order?",
    answer:
      "Whole, half, quarter, eighth and sixteenth shares. Pricing scales directly with the portion, and each campaign lists the exact price per size before you commit.",
  },
  {
    id: "payment",
    question: "How are payments handled?",
    answer:
      "Checkout is processed by Stripe over a secure connection. We never see or store your card details, and you receive confirmation as soon as payment clears.",
  },
  {
    id: "refunds",
    question: "What is your refund policy?",
    answer:
      "All sales are final. If your order cannot be fulfilled for any reason, you receive a full refund within 48 hours of the campaign ending. Any issues, email info@farmerboaz.com and we will sort it out.",
  },
  {
    id: "organic",
    image: is_the_produce_organic,
    question: "Is the produce organic?",
    answer:
      "We partner with farms that follow organic and regenerative practices, so you receive the best quality available for each season.",
  },
  {
    id: "inspection",
    question: "How is the meat inspected?",
    answer:
      "Community share meat has not been inspected by provincial or federal food safety authorities. It is intended only for private, non-commercial use among community members — resale or serving it to the general public is not permitted.",
  },
];

const FAQ = () => {
  const [openId, setOpenId] = useState(QUESTIONS[0].id);

  return (
    <section id="faq" className="section section--alt faq">
      <div className="container">
        <div className="faq-layout">
          <div className="faq-aside" data-reveal>
            <span className="eyebrow">Good to know</span>
            <h2>Frequently asked questions</h2>
            <p>
              Everything about ordering, delivery, payment and how community shares actually work.
            </p>
            <Link to="/order-now" className="btn">
              Browse open campaigns
            </Link>
            <p className="faq-contact">
              Still unsure?{" "}
              <a href="mailto:info@farmerboaz.com">Email us</a> and a human will answer.
            </p>
          </div>

          <div className="faq-list" data-reveal style={{ "--reveal-delay": "120ms" }}>
            {QUESTIONS.map((item) => {
              const isOpen = openId === item.id;
              return (
                <div className={`faq-item ${isOpen ? "is-open" : ""}`} key={item.id}>
                  <h3>
                    <button
                      type="button"
                      className="faq-question"
                      aria-expanded={isOpen}
                      aria-controls={`faq-panel-${item.id}`}
                      id={`faq-trigger-${item.id}`}
                      onClick={() => setOpenId(isOpen ? null : item.id)}
                    >
                      {item.question}
                      <span className="faq-icon" aria-hidden="true" />
                    </button>
                  </h3>
                  <div
                    className="faq-answer"
                    id={`faq-panel-${item.id}`}
                    role="region"
                    aria-labelledby={`faq-trigger-${item.id}`}
                  >
                    <div className="faq-answer-inner">
                      <div className="faq-answer-body">
                        {item.image && (
                          <span className="faq-thumb">
                            <img src={item.image} alt="" loading="lazy" />
                          </span>
                        )}
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
